import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('render_jirawatchesfield_nin');
	},
};
